<div class="luxury-products-section">

    <!-- Floating Background Elements -->
    <div class="bg-blur blur-1"></div>
    <div class="bg-blur blur-2"></div>

    <div class="container">

        <!-- SECTION TITLE -->
        <div class="section-header" *ngFor="let Content of sectionTitle">
<!-- 
            <span class="mini-title">
                Featured Collection
            </span> -->

            <h2>
                {{Content.title}}
            </h2>

            <p>
                {{Content.paragraph}}
            </p>

        </div>

        <!-- PRODUCT SLIDER -->
        <div class="products-wrapper" >

            <owl-carousel-o [options]="productsSlidesOptions" style="min-height:800px !important;">
                <div style="min-height:800px!important;">
                </div>
                <ng-template carouselSlide *ngFor="let Content of singleProductsBox; let i = index">

                    <!-- PRODUCT CARD -->
                    <div class="immersive-card mb-4">

                        <!-- TOP IMAGE -->
                        <div class="image-section" >

                            <!-- Glow -->
                            <div class="image-glow"></div>

                            <!-- Badge -->
                            <div class="floating-badge" *ngIf="Content.sale">
                                {{Content.sale}}
                            </div>

                            <!-- Wishlist -->
                            <!-- <button class="floating-icon">
                                <i class='bx bx-heart'></i>
                            </button> -->

                            <!-- Product Image -->
                            <a routerLink="/{{Content.detailsLink}}">
                                <img
                                    [src]="Content.mainImg"
                                    class="food-image"
                                    alt="food">
                            </a>

                            <!-- Hover Overlay -->
                            <!-- <div class="hover-layer">

                                <button class="quick-btn">
                                    Quick View
                                </button>

                            </div> -->

                        </div>

                        <!-- CONTENT -->
                        <div class="card-content">

                            <!-- Rating -->
                            <div class="rating-row">

                                <div class="stars">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star-half'></i>
                                </div>

                                <span class="rating-text">
                                    4.8
                                </span>

                            </div>

                            <!-- Product Title -->
                            <h3>
                                <a routerLink="/{{Content.detailsLink}}">
                                    {{Content.title}}
                                </a>
                            </h3>

                            <!-- Description -->
                            <p class="food-desc">
                                 {{ Content.description | slice:0:100 }}
                                <span *ngIf="Content.description?.length > 100">...</span>
                            </p>
 <!-- Price -->
                                <div class="price-area">

                                    <span class="new-price">
                                        {{Content.newPrice}}
                                    </span>

                                    <span
                                        class="old-price"
                                        *ngIf="Content.oldPrice">

                                        {{Content.oldPrice}}

                                    </span>

                                </div>
                            <!-- Bottom Row -->
                            <div class="bottom-row">

                               



                                 <!-- Quantity -->
                                <div class="luxury-qty-box">

                                    <button
                                        class="luxury-qty-btn"
                                        (click)="decreaseQuantity(Content)">

                                        <i class='bx bx-minus'></i>

                                    </button>

                                    <span class="luxury-qty-value">
                                        {{Content.quantity || 1}}
                                    </span>

                                    <button
                                        class="luxury-qty-btn"
                                        (click)="increaseQuantity(Content)">

                                        <i class='bx bx-plus'></i>

                                    </button>

                                </div>



                                <!-- Add Button -->
                                <button class="cart-btn"     (click)="addToCart(Content)">

                                    <i class='bx bx-cart' style="font-size: 30px;"></i>

                                </button>

                            </div>

                        </div>

                    </div>

                </ng-template>

            </owl-carousel-o>

        </div>

    </div>

</div>